var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconHourglass = function SvgIconHourglass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23 28-.012-7.5-4.988-5 4.988-5.012L23 3H8v7.5l5 5-5 4.988V28h15ZM10.5 9.875V5.5h10v4.375l-5 5-5-5Z",
    fill: "#fff"
  })));
};
export default SvgIconHourglass;